const menuDisclosures = document.querySelectorAll('.header__primary-nav details.header__menu-disclosure');

menuDisclosures.forEach((details) => {
  const summary = details.querySelector(':scope > summary');
  const syncExpanded = () => {
    summary.setAttribute('aria-expanded', details.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
  };

  syncExpanded();
  new MutationObserver(syncExpanded).observe(details, { attributes: true, attributeFilter: ['aria-expanded'] });
});

// ADA 2026-10-24: accordions (snippets/accordion.liquid) block the native toggle to animate, so on collapse the
// summary's native state only changes after the animation and VoiceOver stays silent on repeat presses. Mirror the
// details' aria-expanded (set on the press itself) onto its summary, same as the header menus above. Observed at
// document level so accordions rendered later (quick view, drawers) are covered too.
const syncAccordionSummary = (details) => {
  const summary = details.querySelector(':scope > summary');
  if (summary) summary.setAttribute('aria-expanded', details.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
};

document.querySelectorAll('details[is="accordion-disclosure"]').forEach(syncAccordionSummary);
new MutationObserver((mutations) => {
  mutations.forEach(({ target }) => {
    if (target.matches?.('details[is="accordion-disclosure"]')) syncAccordionSummary(target);
  });
}).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;

    const openMenu = event.target.closest?.('.header__primary-nav details[open]');
    openMenu?.querySelector(':scope > summary').focus();
  },
  true
);

document.addEventListener('keydown', (event) => {
  if (event.key !== ' ') return;

  const linkButton = event.target.closest?.('.header__secondary-nav a[role="button"], line-item-quantity a[role="button"]');
  if (!linkButton) return;

  event.preventDefault();
  linkButton.click();
});

const announcer = document.createElement('div');
announcer.className = 'sr-only';
announcer.setAttribute('aria-live', 'polite');
announcer.setAttribute('aria-atomic', 'true');
document.body.append(announcer);

const announce = (message) => {
  announcer.textContent = '';
  setTimeout(() => {
    announcer.textContent = message;
  }, 100);
};

const releaseActiveFigures = (target) => {
  document.querySelectorAll('.product-card__figure.is-a11y-swipe-active').forEach((figure) => {
    if (!figure.contains(target)) figure.classList.remove('is-a11y-swipe-active');
  });
};

document.addEventListener('focusin', (event) => {
  releaseActiveFigures(event.target);

  const arrow = event.target.closest?.('.product-card__swipe-arrow');
  if (!arrow) return;

  window.__tmrPrimeSwipeTrackImages?.(arrow.closest('.product-card__swipe').querySelector('.product-card__swipe-track'));
});

let lastPointerDown = { target: null, time: 0 };

document.addEventListener(
  'pointerdown',
  (event) => {
    lastPointerDown = { target: event.target, time: Date.now() };
    releaseActiveFigures(event.target);
  },
  true
);

document.addEventListener('pointerover', (event) => {
  event.target.closest?.('.product-card__figure.is-a11y-swipe-active')?.classList.remove('is-a11y-swipe-active');
});

document.addEventListener(
  'click',
  (event) => {
    const arrow = event.target.closest?.('.product-card__swipe-arrow');
    if (!arrow) return;

    const swipe = arrow.closest('.product-card__swipe');
    const figure = arrow.closest('.product-card__figure');

    if (figure && !figure.matches(':hover')) figure.classList.add('is-a11y-swipe-active');

    setTimeout(() => {
      const dots = [...swipe.querySelectorAll('.product-card__dot')];
      const current = dots.findIndex((dot) => dot.classList.contains('product-card__dot--active')) + 1;
      if (!current) return;

      const card = swipe.closest('product-card');
      const image = swipe.querySelectorAll('.product-card__swipe-slide:not([data-clone]) img')[current - 1];
      const description = image?.alt || card?.querySelector('.product-title')?.textContent.trim();

      announce(`Image ${current} of ${dots.length}${description ? `, ${description}` : ''}`);
    });
  },
  true
);

const syncCardImageAlt = (card) => {
  const title = card.querySelector('.product-title')?.textContent.trim();
  const image = card.querySelector('.product-card__media img.product-card__image--primary');
  if (title && image) image.alt = title;
};

const syncCardSlides = (swipe) => {
  if (swipe.querySelector('a.product-card__swipe-slide')) return;

  const media = swipe.closest('.product-card__figure')?.querySelector(':scope > .product-card__media');
  const showActiveSlide = !media || getComputedStyle(media).display === 'none';
  const slides = swipe.querySelectorAll('.product-card__swipe-slide:not([data-clone])');
  const dots = [...swipe.querySelectorAll('.product-card__dot')];
  const active = Math.max(0, dots.findIndex((dot) => dot.classList.contains('product-card__dot--active')));

  slides.forEach((slide, index) => {
    if (showActiveSlide && index === active) {
      slide.removeAttribute('aria-hidden');
      const image = slide.querySelector('img');
      if (image && !image.alt) image.alt = swipe.closest('product-card')?.querySelector('.product-title')?.textContent.trim() || '';
    } else {
      slide.setAttribute('aria-hidden', 'true');
    }
  });
};

const syncAllCardSlides = () => document.querySelectorAll('.product-card__swipe').forEach(syncCardSlides);
const pendingSwipes = new Set();
let swipeSyncFrame = 0;

const queueSwipeSync = (swipe) => {
  if (!swipe) return;
  pendingSwipes.add(swipe);
  swipeSyncFrame ||= requestAnimationFrame(() => {
    swipeSyncFrame = 0;
    pendingSwipes.forEach(syncCardSlides);
    pendingSwipes.clear();
  });
};

new MutationObserver((mutations) => {
  mutations.forEach(({ type, target, attributeName, addedNodes }) => {
    if (type === 'attributes') {
      if (attributeName === 'handle' && target.matches('product-card')) syncCardImageAlt(target);
      if (attributeName === 'class' && target.classList.contains('product-card__dot')) queueSwipeSync(target.closest('.product-card__swipe'));
      return;
    }

    if (target.closest?.('.product-card__swipe')) {
      queueSwipeSync(target.closest('.product-card__swipe'));
      return;
    }

    addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches('.product-card__swipe')) queueSwipeSync(node);
      node.querySelectorAll('.product-card__swipe').forEach(queueSwipeSync);
    });
  });
}).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'handle'] });

syncAllCardSlides();
window.matchMedia('(max-width: 699px)').addEventListener('change', syncAllCardSlides);

const cartDrawer = document.querySelector('cart-drawer');
let quickAddOpener = null;
let quickAddOpenedAt = 0;

document.addEventListener(
  'click',
  (event) => {
    if (event.target.closest?.('[aria-controls="cart-drawer"]')) quickAddOpener = null;
    if (quickAddOpener && event.target.closest?.('quick-buy-modal')) quickAddOpenedAt = Date.now();

    const quickAdd = event.target.closest?.('.product-card__quick-add-button');
    if (!quickAdd) return;

    const pressedWithPointer = quickAdd.contains(lastPointerDown.target) && Date.now() - lastPointerDown.time < 1500;
    quickAddOpener = pressedWithPointer ? null : quickAdd;
    quickAddOpenedAt = Date.now();
  },
  true
);

cartDrawer?.addEventListener('dialog:after-show', () => {
  if (!quickAddOpener || Date.now() - quickAddOpenedAt > 15000) {
    quickAddOpener = null;
    return;
  }

  const closeButton = cartDrawer.shadowRoot?.querySelector('[part~="close-button"]');
  (closeButton || cartDrawer).focus({ preventScroll: true });
});

cartDrawer?.addEventListener('dialog:after-hide', () => {
  const opener = quickAddOpener;
  quickAddOpener = null;
  if (!opener?.isConnected) return;

  requestAnimationFrame(() => opener.focus({ preventScroll: true }));
});

window.addEventListener(
  'keydown',
  (event) => {
    if (!cartDrawer?.open) return;

    const pressedClose =
      ['Enter', ' '].includes(event.key) &&
      event.composedPath().some((node) => node.getAttribute?.('is') === 'dialog-close-button' && cartDrawer.shadowRoot?.contains(node));

    if (event.key === 'Escape' || pressedClose) window.__tmrCartDrawerLastManualCloseAt = Date.now();
  },
  true
);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !cartDrawer?.open) return;

  requestAnimationFrame(() => {
    const otherDialogOpen = [...document.querySelectorAll('[open]')].some((dialog) => dialog !== cartDrawer && dialog.focusTrap?.active);
    if (cartDrawer.open && !otherDialogOpen) cartDrawer.hide();
  });
});

const linkText = (link) => link.textContent.replace(/\s+/g, ' ').trim();

const contactLinkTypes = [
  { prefix: 'mailto:', label: 'Email Address' },
  { prefix: 'tel:', label: 'Phone Number' },
];

const enhanceLink = (link) => {
  if (link.dataset.a11yLink) return;
  link.dataset.a11yLink = '';

  const href = (link.getAttribute('href') || '').trim();
  const contactType = contactLinkTypes.find(({ prefix }) => href.toLowerCase().startsWith(prefix));

  if (contactType) {
    const value = decodeURIComponent(href.slice(contactType.prefix.length).split('?')[0]).trim();

    if (value) {
      link.setAttribute('aria-label', `${contactType.label}: ${linkText(link) || value}`);
    }
  }

  if (link.target !== '_blank') return;

  const name = link.getAttribute('aria-label') || linkText(link);
  if (name) link.setAttribute('aria-label', `${name} (opens in a new tab)`);
};

const enhanceLinks = (root) => {
  if (root.matches?.('a[href]')) enhanceLink(root);
  root.querySelectorAll?.('a[href^="mailto:" i], a[href^="tel:" i], a[target="_blank"]').forEach(enhanceLink);
  const sortSelects = root.matches?.('select.oke-sortSelect-sort') ? [root] : [...(root.querySelectorAll?.('select.oke-sortSelect-sort') || [])];
  sortSelects.forEach((select) => select.setAttribute('aria-label', 'Sort reviews'));
};

const hideSeparators = (root) => {
  if (root.matches?.('hr, br')) root.setAttribute('aria-hidden', 'true');
  root.querySelectorAll?.('hr:not([aria-hidden]), br:not([aria-hidden])').forEach((element) => element.setAttribute('aria-hidden', 'true'));
};

enhanceLinks(document);
hideSeparators(document);

new MutationObserver((mutations) => {
  mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
    if (node.nodeType !== 1) return;
    enhanceLinks(node);
    hideSeparators(node);
  }));
}).observe(document.body, { childList: true, subtree: true });

const swatchGroupLabels = { rose: 'Rose color', box: 'Box color' };
const isRendered = (element) => element.getClientRects().length > 0;

const syncSwatchGroup = (row) => {
  const root = row.closest('[data-tmr-card-swatches]');
  const title = row.closest('product-card, .product-card')?.querySelector('.product-title')?.textContent.trim() || root?.dataset.productTitle || '';
  const groupLabel = swatchGroupLabels[root?.dataset.swatchMode] || 'Color';
  const swatches = [...row.querySelectorAll('.tmr-card-swatch')];
  const selected = swatches.find((swatch) => swatch.classList.contains('is-selected')) || swatches.find(isRendered);

  row.setAttribute('role', 'radiogroup');
  row.setAttribute('aria-label', title ? `${groupLabel}, ${title}` : groupLabel);

  swatches.forEach((swatch) => {
    swatch.setAttribute('role', 'radio');
    swatch.setAttribute('aria-checked', swatch.classList.contains('is-selected') ? 'true' : 'false');
    swatch.tabIndex = swatch === selected ? 0 : -1;
  });
};

const pendingSwatchRows = new Set();
let swatchSyncFrame = 0;

const queueSwatchSync = (row) => {
  if (!row) return;
  pendingSwatchRows.add(row);
  swatchSyncFrame ||= requestAnimationFrame(() => {
    swatchSyncFrame = 0;
    pendingSwatchRows.forEach(syncSwatchGroup);
    pendingSwatchRows.clear();
  });
};

document.querySelectorAll('.tmr-card-swatches__row').forEach(syncSwatchGroup);

new MutationObserver((mutations) => {
  mutations.forEach(({ target, addedNodes }) => {
    queueSwatchSync(target.closest?.('.tmr-card-swatches__row'));
    addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches('.tmr-card-swatches__row')) queueSwatchSync(node);
      node.querySelectorAll('.tmr-card-swatches__row').forEach(queueSwatchSync);
    });
  });
}).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });

document.addEventListener('keydown', (event) => {
  const swatch = event.target.closest?.('.tmr-card-swatch[role="radio"]');
  if (!swatch) return;

  const swatches = [...swatch.closest('.tmr-card-swatches__row').querySelectorAll('.tmr-card-swatch')].filter(isRendered);
  const index = swatches.indexOf(swatch);
  const steps = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
  let next;

  if (event.key in steps) next = swatches[(index + steps[event.key] + swatches.length) % swatches.length];
  else if (event.key === 'Home') next = swatches[0];
  else if (event.key === 'End') next = swatches[swatches.length - 1];
  if (!next) return;

  event.preventDefault();
  next.focus();
  if (next !== swatch) next.click();
});

const keepFocusAfterReveal = (event) => {
  if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;

  const more = event.target.closest?.('.tmr-card-swatch-more');
  if (!more) return;

  const row = more.closest('.tmr-card-swatches__row');
  const firstHidden = [...row.querySelectorAll('.tmr-card-swatch')].find((swatch) => !isRendered(swatch));

  setTimeout(() => {
    if (!more.isConnected && firstHidden && document.activeElement === document.body) firstHidden.focus();
  });
};

window.addEventListener('click', keepFocusAfterReveal, true);
window.addEventListener('keydown', keepFocusAfterReveal, true);

const syncProductGallery = (gallery) => {
  const slideSets = new Map();
  gallery.querySelectorAll('.product-gallery__media').forEach((slide) => {
    if (slide.hidden) return;
    const container = slide.closest('.swiper-wrapper') || slide.parentElement;
    slideSets.set(container, [...(slideSets.get(container) || []), slide]);
  });
  slideSets.forEach((slides) => slides.forEach((slide, index) => {
    const description = slide.querySelector('img:not([aria-hidden="true"])')?.alt || slide.getAttribute('aria-label')?.split(' - Image ')[0] || 'Product media';
    slide.setAttribute('aria-label', `${description} - Image ${index + 1} of ${slides.length} in gallery viewer`);
  }));

  const thumbnails = [...gallery.querySelectorAll('.product-gallery__thumbnail')].filter((thumbnail) => !thumbnail.hidden);
  thumbnails.forEach((thumbnail, index) => {
    const description = thumbnail.querySelector('img')?.alt || 'Product image';
    thumbnail.setAttribute('aria-label', `${description} - View image ${index + 1} of ${thumbnails.length} in gallery viewer`);
  });
};

const initProductGallery = (gallery) => {
  if (gallery.dataset.a11yGallery) return;
  gallery.dataset.a11yGallery = '';

  syncProductGallery(gallery);
  new MutationObserver(() => syncProductGallery(gallery)).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
};

document.querySelectorAll('product-gallery').forEach(initProductGallery);

new MutationObserver((mutations) => {
  mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
    if (node.nodeType !== 1) return;
    if (node.matches('product-gallery')) initProductGallery(node);
    node.querySelectorAll('product-gallery').forEach(initProductGallery);
  }));
}).observe(document.body, { childList: true, subtree: true });

window.addEventListener('click', (event) => {
  const control = event.target.closest?.('product-gallery .product-gallery__thumbnail, product-gallery .page-dots button');
  if (!control) return;

  const controls = [...control.parentElement.children].filter((item) => item.matches('button') && !item.hidden);
  const position = controls.indexOf(control) + 1;
  if (position) announce(`Image ${position} of ${controls.length} is visible in gallery viewer`);
}, true);

const contactFormStatus = document.querySelector('form[action*="/contact"] .banner[role]');

if (contactFormStatus) {
  let contactStatusTimer = 0;

  const announceContactStatus = (delay) => {
    if (contactStatusTimer) return;

    contactStatusTimer = setTimeout(() => {
      contactFormStatus.focus();
      announce(contactFormStatus.textContent.replace(/\s+/g, ' ').trim());
    }, delay);
  };

  if (document.readyState === 'complete') announceContactStatus(1000);
  else {
    window.addEventListener('load', () => announceContactStatus(1000), { once: true });
    announceContactStatus(3000);
  }
}

const sidebarMenu = document.getElementById('sidebar-menu');

if (sidebarMenu) {
  const sidebarPanel = sidebarMenu.querySelector('header-sidebar-collapsible-panel');
  const sidebarMainPanel = sidebarMenu.querySelector('.header-sidebar__main-panel');
  const mobileQuery = window.matchMedia(window.themeVariables?.mediaQueries?.['md-max'] || '(max-width: 999px)');
  const menuToggles = () => [...document.querySelectorAll('[aria-controls="sidebar-menu"]')].filter(isRendered);
  const toggleContainers = () => menuToggles().map((toggle) => toggle.parentElement);
  let restoreOutside = null;

  const inertOutside = (keep) => {
    const changed = [];
    const walk = (parent) => [...parent.children].forEach((child) => {
      if (keep.includes(child)) return;
      if (keep.some((element) => child.contains(element))) return walk(child);
      if (child.inert || ['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE', 'NOSCRIPT'].includes(child.tagName)) return;
      child.inert = true;
      changed.push(child);
    });

    walk(document.body);
    return () => changed.forEach((element) => (element.inert = false));
  };

  const syncToggleLabels = () => {
    document.querySelectorAll('[aria-controls="sidebar-menu"] .sr-only').forEach((label) => {
      label.dataset.a11yOpenLabel ||= label.textContent;
      label.textContent = sidebarMenu.open ? 'Close navigation menu' : label.dataset.a11yOpenLabel;
    });
  };

  sidebarMenu.addEventListener('dialog:before-show', () => {
    sidebarMenu.focusTrap?.updateContainerElements?.([sidebarMenu, sidebarMenu.shadowRoot, ...toggleContainers()]);
  });

  sidebarMenu.addEventListener('toggle', (event) => {
    if (event.target !== sidebarMenu) return;

    syncToggleLabels();
    restoreOutside?.();
    restoreOutside = null;

    if (sidebarMenu.open) {
      sidebarMenu.removeAttribute('aria-modal');
      restoreOutside = inertOutside([sidebarMenu, ...menuToggles()]);
    }
  });

  sidebarMenu.addEventListener('dialog:before-hide', () => {
    restoreOutside?.();
    restoreOutside = null;
  });

  if (sidebarPanel) {
    const syncPanelRole = () => {
      if (sidebarPanel.getAttribute('role') !== 'group') sidebarPanel.setAttribute('role', 'group');
    };

    const syncMainPanel = () => {
      if (sidebarMainPanel) sidebarMainPanel.inert = sidebarPanel.hasAttribute('aria-activedescendant') && mobileQuery.matches;
    };

    syncPanelRole();
    new MutationObserver(syncPanelRole).observe(sidebarPanel, { attributes: true, attributeFilter: ['role'] });
    new MutationObserver(syncMainPanel).observe(sidebarPanel, { attributes: true, attributeFilter: ['aria-activedescendant'] });
    mobileQuery.addEventListener('change', syncMainPanel);

    sidebarPanel.addEventListener('dialog:before-show', () => {
      sidebarPanel.focusTrap?.updateContainerElements?.([sidebarPanel, ...toggleContainers()]);
    });

    new MutationObserver((mutations) => {
      mutations.forEach(({ target }) => {
        if (target.hidden || !sidebarMenu.open) return;

        const back = target.querySelector('[data-action="close-panel"]');
        const first = isRendered(back) ? back : target.querySelector('a[href], button, summary');
        requestAnimationFrame(() => first?.focus({ preventScroll: true }));
      });
    }).observe(sidebarPanel, { subtree: true, attributes: true, attributeFilter: ['hidden'] });

    window.addEventListener(
      'keydown',
      (event) => {
        const activePanel = sidebarPanel.getAttribute('aria-activedescendant');
        if (event.key !== 'Escape' || !activePanel || !sidebarMenu.open) return;

        const back = sidebarPanel.querySelector(`#${CSS.escape(activePanel)} [data-action="close-panel"]`);
        if (!back || !isRendered(back)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        back.click();
      },
      true
    );
  }
}

const autoplayCarouselFor = (element) => {
  const carousel = element?.closest?.('[autoplay]') || document.getElementById(element?.closest?.('[aria-controls]')?.getAttribute('aria-controls') || '');
  return carousel?.hasAttribute('autoplay') && carousel.player ? carousel : null;
};

const mobileAutoplayQuery = window.matchMedia('(max-width: 699px)');
const holdsAutoplayFocus = (carousel) => autoplayCarouselFor(document.activeElement) === carousel;
let focusPausedCarousel = null;

const releaseAutoplayCarousel = () => {
  const carousel = focusPausedCarousel;
  focusPausedCarousel = null;
  carousel?.player.resume(true);
};

document.addEventListener('focusin', (event) => {
  const carousel = autoplayCarouselFor(event.target);
  if (carousel === focusPausedCarousel) return;

  releaseAutoplayCarousel();

  const pressedWithPointer = Date.now() - lastPointerDown.time < 1500 && event.target.contains(lastPointerDown.target);
  if (!carousel || pressedWithPointer || !mobileAutoplayQuery.matches) return;

  if (!carousel.dataset.a11yAutoplayHold) {
    carousel.dataset.a11yAutoplayHold = '';
    const keepPaused = () => {
      if (focusPausedCarousel === carousel && holdsAutoplayFocus(carousel)) carousel.player.pause();
    };
    carousel.player.addEventListener('player:start', keepPaused);
    carousel.player.addEventListener('player:resume', keepPaused);
  }

  focusPausedCarousel = carousel;
  carousel.player.pause();
});

document.addEventListener('focusout', (event) => {
  if (focusPausedCarousel && !event.relatedTarget) {
    requestAnimationFrame(() => {
      if (focusPausedCarousel && !holdsAutoplayFocus(focusPausedCarousel)) releaseAutoplayCarousel();
    });
  }
});

const mobileDotStateActive = (navigation) => mobileAutoplayQuery.matches && !!document.getElementById(navigation.getAttribute('aria-controls'))?.hasAttribute('autoplay');

const moveDotState = (button) => {
  if (!button.hasAttribute('aria-current')) return;
  button.dataset.a11yCurrent = button.getAttribute('aria-current');
  button.removeAttribute('aria-current');
};

const restoreDotState = (button) => {
  if (!('a11yCurrent' in button.dataset)) return;
  button.setAttribute('aria-current', button.dataset.a11yCurrent);
  delete button.dataset.a11yCurrent;
};

const syncDotState = (navigation) => {
  navigation.querySelectorAll(':scope > button').forEach(mobileDotStateActive(navigation) ? moveDotState : restoreDotState);
};

document.querySelectorAll('carousel-navigation[aria-controls]').forEach((navigation) => {
  syncDotState(navigation);
  new MutationObserver(() => {
    if (mobileDotStateActive(navigation)) navigation.querySelectorAll(':scope > button[aria-current]').forEach(moveDotState);
  }).observe(navigation, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
});

mobileAutoplayQuery.addEventListener('change', () => document.querySelectorAll('carousel-navigation[aria-controls]').forEach(syncDotState));

document.querySelectorAll('.shopify-section--blog-posts').forEach((section) => {
  const heading = section.querySelector('.section-header :is(h1, h2, h3, h4, h5, h6)')?.textContent.trim();
  const link = section.querySelector('.justify-self-center > a.button');
  const linkText = link?.textContent.trim();
  if (heading && linkText) link.setAttribute('aria-label', `${heading}, ${linkText}`);
});

// ADA 2026-10-24: Okendo's reviews app injects a hidden star sprite (<svg id="oke-star-symbols">) into <body> with no
// name and no aria-hidden, which WAVE reports as "Missing alternative text". It is decorative (display:none), so hide
// it from assistive tech. Okendo replaces the sprite with a new one after load (seen on the product page), so the
// observer stays on; it only watches <body>'s direct children.
const hideOkendoStarSprite = () => {
  const sprite = document.getElementById('oke-star-symbols');
  if (sprite && sprite.getAttribute('aria-hidden') !== 'true') sprite.setAttribute('aria-hidden', 'true');
};

hideOkendoStarSprite();
new MutationObserver(hideOkendoStarSprite).observe(document.body, { childList: true });
